var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var Svg3DModel = function Svg3DModel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.0204,
    cy: 95.4082,
    r: 5.61224,
    transform: "rotate(-180 46.0204 95.4082)",
    fill: "#FFF1B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.4082,
    cy: 59.4898,
    r: 20.2041,
    transform: "rotate(-180 95.4082 59.4898)",
    fill: "#FDF0FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9662 90.6608L75.205 101.02V94.9112C75.205 93.8967 76.0273 93.0744 77.0418 93.0744C78.0562 93.0744 78.8786 93.8967 78.8786 94.9112V101.02L98.1174 90.6608C98.7121 90.3406 99.0832 89.7198 99.0835 89.0444V68.5951L94.4437 71.0895C93.55 71.5704 92.4357 71.2357 91.9549 70.3419C91.474 69.4482 91.8087 68.3339 92.7024 67.8531L97.0428 65.5221L77.9124 55.2195C77.3689 54.9268 76.7147 54.9268 76.1711 55.2195L57.0407 65.5221L61.3811 67.8549C62.2748 68.3357 62.6095 69.4501 62.1287 70.3438C61.6478 71.2375 60.5335 71.5722 59.6398 71.0914L55 68.5951V89.0444C55.0004 89.7198 55.3714 90.3406 55.9662 90.6608V90.6608ZM68.0763 73.56C68.307 73.1307 68.699 72.8107 69.1658 72.6705C69.6326 72.5303 70.136 72.5813 70.5652 72.8125L77.0418 76.2951L83.5184 72.8051C84.4121 72.3243 85.5264 72.659 86.0073 73.5527C86.4881 74.4464 86.1534 75.5607 85.2597 76.0416L78.8786 79.4819V83.8903C78.8786 84.9047 78.0562 85.7271 77.0418 85.7271C76.0273 85.7271 75.205 84.9047 75.205 83.8903V79.4819L68.8239 76.0526C68.3935 75.8218 68.0728 75.4292 67.9325 74.9615C67.7923 74.4938 67.844 73.9895 68.0763 73.56V73.56Z",
    fill: "url(#paint0_linear_1112_5318)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5318",
    x1: 99.0835,
    y1: 55,
    x2: 55,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg3DModel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/3d-model.b9a6e4c02a5482e03196f50cd88c66e0.svg";